import { formatDate } from 'ui-component-library/utils/helpers'
import HeadlineThree from 'ui-component-library/components/00-Primitives/Headlines/HeadlineThree'
import style from './style.scss'

const DATE_FORMAT = 'MMMM d, yyyy'
const TIME_FORMAT = 'h:mm a'

type OnlineEventHeaderProps = {
  dateText: string
  timeText: string
}

function OnlineEventHeader({ dateText, timeText }: OnlineEventHeaderProps) {
  return (
    <header className={style.paddedContent}>
      <HeadlineThree className={style.header}>Online</HeadlineThree>
      <p className={style.header}>{dateText}</p>
      <p className={style.header}>{timeText} PT</p>
    </header>
  )
}

type InPersonEventHeaderProps = {
  dateText: string
  timeText: string
  location: {
    city: string
    state?: string
    country: string
  }
}

function InPersonEventHeader({
  dateText,
  timeText,
  location,
}: InPersonEventHeaderProps) {
  const { city, state, country } = location
  const locationText = [city, state, country].filter(Boolean).join(', ')

  return (
    <header className={style.paddedContent}>
      <HeadlineThree className={style.header}>{locationText}</HeadlineThree>
      <p className={style.header}>{dateText}</p>
      <p className={style.header}>{timeText} PT</p>
    </header>
  )
}

type Props = {
  date: string
  isOnlineSeminar: boolean
  location?: {
    city: string
    state?: string
    country: string
  }
}

function EventHeader({ isOnlineSeminar, location, date }: Props) {
  const dateText = formatDate(date, DATE_FORMAT)
  const timeText = formatDate(date, TIME_FORMAT)

  return (
    <header className={style.wrapper}>
      {isOnlineSeminar && (
        <OnlineEventHeader dateText={dateText} timeText={timeText} />
      )}
      {!isOnlineSeminar && location && (
        <InPersonEventHeader
          dateText={dateText}
          timeText={timeText}
          location={location}
        />
      )}
    </header>
  )
}

export default EventHeader
